import Repository from '@/api/core'
import utils from '@/helpers/utils.js'
const baseURL = process.env.VUE_APP_API_ANONYMOUS_PAYMENT + '/anonymous-active-code'

const fetch = (params) => {
  return Repository(baseURL).fetch(params)
}

const update = (id, params) => {
  return Repository(baseURL).update(id, params)
}

const count = (params) => {
  return Repository(baseURL + '/count').fetch({...utils.cleanObject(params)})
}


export default {
  fetch,
  update,
  count,
}
